import React from 'react';
import PropTypes from 'prop-types';
import DivLayoutV2FieldGrid from './DivLayoutV2FieldGrid';
import './DivLayoutV2.css';

const DivLayoutV2Section = ({ title, fields, children }) => (
  <div className="div-layout-v2-section">
    {title && <div className="div-layout-v2-section-header">{title}</div>}
    <div className="div-layout-v2-section-body">
      {fields?.length ? (
        <DivLayoutV2FieldGrid fields={fields} />
      ) : (
        <DivLayoutV2FieldGrid>{children}</DivLayoutV2FieldGrid>
      )}
    </div>
  </div>
);

DivLayoutV2Section.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.array,
  children: PropTypes.node,
};

export default DivLayoutV2Section;
